import axiosClient from '@/api/axios'
import { ProductModel } from '@/models/ProductModel'
import { ref } from 'vue'

export function useProduct() {
    const products = ref<ProductModel[]>([])
    const isLoading = ref(false)
    const error = ref<string | null>(null)

    const listProducts = async (params: { page?: number; perPage?: number } = {}) => {
        isLoading.value = true
        error.value = null
        try {
            const response = await axiosClient.get(`/customer/products`, { params })
            products.value = response.data.data // Assuming response structure { data: [] } from ResponseMapper
            return response.data
        } catch (err: any) {
            error.value = err.message || 'Erro ao carregar produtos'
            console.error(err)
            throw err
        } finally {
            isLoading.value = false
        }
    }

    return {
        products,
        isLoading,
        error,
        listProducts
    }
}
